import { render, staticRenderFns } from "./Draw.vue?vue&type=template&id=b664d118"
import script from "./Draw.vue?vue&type=script&lang=js"
export * from "./Draw.vue?vue&type=script&lang=js"
import style0 from "./Draw.vue?vue&type=style&index=0&id=b664d118&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b664d118')) {
      api.createRecord('b664d118', component.options)
    } else {
      api.reload('b664d118', component.options)
    }
    module.hot.accept("./Draw.vue?vue&type=template&id=b664d118", function () {
      api.rerender('b664d118', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Draw.vue"
export default component.exports